import React from "react";
import { track } from "../lib/analytics";
import { useReveal } from "../lib/useReveal";
import Reveal from "./Reveal";
import { PillarIcon } from "./Illustrations";

function PillarCard({ title, copy, accent, iconVariant }) {
  return (
    <div className={`card card--pillar ${accent ? `card--${accent}` : ""}`}>
      <div className="card__head">
        <PillarIcon variant={iconVariant || "g"} />
        <h3 className="card__title">{title}</h3>
      </div>
      <p className="card__copy">{copy}</p>
    </div>
  );
}

export default function Pillars({ onOpenModal }) {
  const { ref, inView } = useReveal();

  return (
    <section className="section" id="pillars">
      <div className="container">
        <div
          className={`section__head reveal ${inView ? "reveal--in" : ""}`}
          ref={ref}
        >
          <h2 className="section__title">Your Industrial Scaling Engine</h2>
          <p className="section__subtitle">
            Market, Structure, Capital. Built as one system.
          </p>
        </div>

        <div className="grid grid--3">
          <Reveal>
            <PillarCard
              accent="green"
              iconVariant="g"
              title="Market Access & High Velocity Visibility via Global Showcases"
              copy="We don't just 'list' your brand; we curate its global entry. Using nearly two decades of campaign mastery from 360 Degrees, we ensure your products are positioned as the Gold Standard of African industry. Our Global Showcases put your brand in front of local and international high-intent buyers with curated placements in our proprietary international retail networks and high-trust sales channels.
"
            />
          </Reveal>

          <Reveal>
            <PillarCard
              accent="blue"
              iconVariant="b"
              title="Structure via The SmartUp Dashboard"
              copy="Move from a local factory to a global-standard Manufacturing Powerhouse.
Visibility is a liability if your structure cannot handle the spotlight. We re-engineer your 'Back-End' to ensure your business is sustainable, bankable, and built to last. We convert your operations into a bankable institution by providing an integrated suite of governance tools, compliance trackers and SOP management modules designed to scale your team’s capacity for sustainable global growth.
"
            />
          </Reveal>

          <Reveal>
            <PillarCard
              iconVariant="n"
              title="Capital via Inventory Credit & Investor Access"
              copy="Scale requires more than just sales; it requires liquidity. We bridge the capital gap that prevents Nigerian SMEs from meeting global demand. We leverage verified sales data within our ecosystem and unlock Inventory Credit and Global Impact Investors looking for high-growth Specialty Brands.
"
            />
          </Reveal>
        </div>

        <div className="section__cta ">
          <a
            className="btn btn--secondary"
            href="http://waitlist.smartup360.com/"
            onClick={() => {
              track("cta_click", { source: "hero_secondary" });
            }}
          >
            Secure my spot on the waitlist
          </a>
        </div>
      </div>
    </section>
  );
}
